var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8922 7.33325C12.5872 6.96558 12.3308 6.55674 12.1322 6.1167L8.10938 8.59522C8.41421 8.96289 8.67074 9.37188 8.8694 9.81177L12.8922 7.33325Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8694 14.1882C8.67074 14.6281 8.41421 15.0371 8.10938 15.4048L12.1322 17.8833C12.3308 17.4433 12.5872 17.0344 12.8922 16.6667L8.8694 14.1882Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89833 12C7.89833 9.83374 6.12675 8.07153 3.94931 8.07153C1.77158 8.07153 0 9.83374 0 12C0 14.1659 1.77158 15.9284 3.94931 15.9284C6.12675 15.9284 7.89833 14.1662 7.89833 12Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0506 7.85655C19.2283 7.85655 20.9999 6.09434 20.9999 3.92842C20.9999 1.76221 19.2283 0 17.0506 0C14.873 0 13.1016 1.76221 13.1016 3.92842C13.1016 6.09434 14.873 7.85655 17.0506 7.85655Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0506 16.1436C14.873 16.1436 13.1016 17.9058 13.1016 20.0717C13.1016 22.2379 14.873 24.0001 17.0506 24.0001C19.2283 24.0001 20.9999 22.2379 20.9999 20.0717C20.9999 17.9058 19.2283 16.1436 17.0506 16.1436Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWhite);
export default __webpack_public_path__ + "static/media/share-white.f04b7283ce7e7ac82053c5625d36e119.svg";
export { ForwardRef as ReactComponent };